let user = {
  token: null,
  id: null,
  group: null,
  name: null,
  authenticated: false,
  passwordResetData: null
};

try {
  Object.assign(
    user,
    JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user"))
  );
} catch (error) {
  localStorage.removeItem("user");
  sessionStorage.removeItem("user");
}

user.authenticated = Boolean(user.token);

export default user;
